import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Categorie from './Categorie';
import { fetchCategories } from 'store/categorie/categorieActions';

class CategorieContainer extends React.Component {
    componentDidMount() {
        this.props.fetchCategories();
    }

    render() {
        const { categorie, isLoading } = this.props;


        return (
            <Categorie
                categorie={categorie}
                isLoading={isLoading}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    categorie: state.categorie.categories.items.find(x => x.id === ownProps.categorieId),
    isLoading: state.categorie.categories.isLoading
});


const mapDispatchToProps = {
    fetchCategories
};

CategorieContainer.propTypes = {
    categorieId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(CategorieContainer);